import React, { useState } from "react";
import { toast } from "react-toastify";
import DashboardLayout from "../components/DashboardLayout";

export default function ClientsPage() {
    const [activeSubTab, setActiveSubTab] = useState("clients");
    const [searchQuery, setSearchQuery] = useState("");

    // Mock data - will be replaced with API calls
    const [clients] = useState([
        {
            id: 1,
            name: "Rahul Sharma",
            email: "rahul@example.com",
            phone: "+91 98765 43210",
            joinedDate: "2024-01-15",
            status: "active",
            program: "Weight Loss",
            progress: 75,
        },
        {
            id: 2,
            name: "Priya Patel",
            email: "priya@example.com",
            phone: "+91 98765 43211",
            joinedDate: "2024-02-20",
            status: "active",
            program: "Muscle Building",
            progress: 60,
        },
        {
            id: 3,
            name: "Amit Kumar",
            email: "amit@example.com",
            phone: "+91 98765 43212",
            joinedDate: "2023-12-10",
            status: "inactive",
            program: "Yoga",
            progress: 100,
        },
    ]);

    const [leads] = useState([
        {
            id: 1,
            name: "Sneha Reddy",
            email: "sneha@example.com",
            phone: "+91 98765 43213",
            enquiryDate: "2024-03-01",
            status: "new",
            interest: "1:1 Personal Training",
            source: "Website",
        },
        {
            id: 2,
            name: "Vikram Singh",
            email: "vikram@example.com",
            phone: "+91 98765 43214",
            enquiryDate: "2024-02-28",
            status: "contacted",
            interest: "Online Training",
            source: "Referral",
        },
        {
            id: 3,
            name: "Anjali Verma",
            email: "anjali@example.com",
            phone: "+91 98765 43215",
            enquiryDate: "2024-02-25",
            status: "converted",
            interest: "Diet Consultation",
            source: "Social Media",
        },
    ]);

    const filteredClients = clients.filter((client) =>
        client.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
        client.email.toLowerCase().includes(searchQuery.toLowerCase())
    );

    const filteredLeads = leads.filter((lead) =>
        lead.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
        lead.email.toLowerCase().includes(searchQuery.toLowerCase())
    );

    const getStatusBadgeClass = (status) => {
        switch (status) {
            case "active":
                return "badge bg-success";
            case "inactive":
                return "badge bg-secondary";
            case "new":
                return "badge bg-primary";
            case "contacted":
                return "badge bg-warning";
            case "converted":
                return "badge bg-success";
            default:
                return "badge bg-secondary";
        }
    };

    const handleContactClient = (client) => {
        toast.info(`Opening contact for ${client.name}`);
        // In production, this would open a contact modal or initiate communication
    };

    const handleViewDetails = (item) => {
        toast.info(`Viewing details for ${item.name}`);
        // In production, this would open a detailed view modal
    };

    return (
        <DashboardLayout activeTab="clients">
            <div className="clients-tab">
                <div className="tab-header">
                    <div>
                        <h3>
                            <i className="bi bi-people-fill me-2"></i>
                            Clients & Leads
                        </h3>
                        <p className="text-muted">Manage your clients and track new leads</p>
                    </div>
                </div>

                {/* Sub Tabs */}
                <div className="sub-tabs">
                    <button
                        className={`sub-tab-btn ${activeSubTab === "clients" ? "active" : ""}`}
                        onClick={() => setActiveSubTab("clients")}
                    >
                        <i className="bi bi-person-check me-2"></i>
                        My Clients ({clients.length})
                    </button>
                    <button
                        className={`sub-tab-btn ${activeSubTab === "leads" ? "active" : ""}`}
                        onClick={() => setActiveSubTab("leads")}
                    >
                        <i className="bi bi-person-plus me-2"></i>
                        Leads ({leads.length})
                    </button>
                </div>

                {/* Search Bar */}
                <div className="search-section">
                    <div className="search-box">
                        <i className="bi bi-search"></i>
                        <input
                            type="text"
                            className="form-control"
                            placeholder={`Search ${activeSubTab}...`}
                            value={searchQuery}
                            onChange={(e) => setSearchQuery(e.target.value)}
                        />
                    </div>
                </div>

                {/* Clients Tab */}
                {activeSubTab === "clients" && (
                    <div className="clients-content">
                        {filteredClients.length > 0 ? (
                            <div className="clients-grid">
                                {filteredClients.map((client) => (
                                    <div key={client.id} className="client-card">
                                        <div className="client-header">
                                            <div className="client-avatar">
                                                {client.name.charAt(0).toUpperCase()}
                                            </div>
                                            <div className="client-info">
                                                <h6>{client.name}</h6>
                                                <span className={getStatusBadgeClass(client.status)}>
                                                    {client.status.toUpperCase()}
                                                </span>
                                            </div>
                                        </div>

                                        <div className="client-details">
                                            <div className="detail-item">
                                                <i className="bi bi-envelope me-2"></i>
                                                <span>{client.email}</span>
                                            </div>
                                            <div className="detail-item">
                                                <i className="bi bi-telephone me-2"></i>
                                                <span>{client.phone}</span>
                                            </div>
                                            <div className="detail-item">
                                                <i className="bi bi-calendar me-2"></i>
                                                <span>Joined: {new Date(client.joinedDate).toLocaleDateString()}</span>
                                            </div>
                                            <div className="detail-item">
                                                <i className="bi bi-trophy me-2"></i>
                                                <span>{client.program}</span>
                                            </div>
                                        </div>

                                        <div className="client-progress">
                                            <div className="progress-header">
                                                <span>Progress</span>
                                                <strong>{client.progress}%</strong>
                                            </div>
                                            <div className="progress">
                                                <div
                                                    className="progress-bar bg-success"
                                                    style={{ width: `${client.progress}%` }}
                                                ></div>
                                            </div>
                                        </div>

                                        <div className="client-actions">
                                            <button
                                                className="btn btn-sm btn-outline-primary"
                                                onClick={() => handleContactClient(client)}
                                            >
                                                <i className="bi bi-chat-dots me-1"></i>
                                                Contact
                                            </button>
                                            <button
                                                className="btn btn-sm btn-outline-secondary"
                                                onClick={() => handleViewDetails(client)}
                                            >
                                                <i className="bi bi-eye me-1"></i>
                                                View
                                            </button>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        ) : (
                            <div className="empty-state">
                                <i className="bi bi-people" style={{ fontSize: "3rem", color: "#ccc" }}></i>
                                <p className="text-muted mt-2">
                                    {searchQuery ? "No clients found" : "No clients yet"}
                                </p>
                                <p className="text-muted">
                                    {searchQuery
                                        ? "Try a different search term"
                                        : "Your clients will appear here once they join"}
                                </p>
                            </div>
                        )}
                    </div>
                )}

                {/* Leads Tab */}
                {activeSubTab === "leads" && (
                    <div className="leads-content">
                        {filteredLeads.length > 0 ? (
                            <div className="leads-grid">
                                {filteredLeads.map((lead) => (
                                    <div key={lead.id} className="lead-card">
                                        <div className="lead-header">
                                            <div className="lead-avatar">
                                                {lead.name.charAt(0).toUpperCase()}
                                            </div>
                                            <div className="lead-info">
                                                <h6>{lead.name}</h6>
                                                <span className={getStatusBadgeClass(lead.status)}>
                                                    {lead.status.toUpperCase()}
                                                </span>
                                            </div>
                                        </div>

                                        <div className="lead-details">
                                            <div className="detail-item">
                                                <i className="bi bi-envelope me-2"></i>
                                                <span>{lead.email}</span>
                                            </div>
                                            <div className="detail-item">
                                                <i className="bi bi-telephone me-2"></i>
                                                <span>{lead.phone}</span>
                                            </div>
                                            <div className="detail-item">
                                                <i className="bi bi-calendar me-2"></i>
                                                <span>Enquiry: {new Date(lead.enquiryDate).toLocaleDateString()}</span>
                                            </div>
                                            <div className="detail-item">
                                                <i className="bi bi-star me-2"></i>
                                                <span>Interest: {lead.interest}</span>
                                            </div>
                                            <div className="detail-item">
                                                <i className="bi bi-link-45deg me-2"></i>
                                                <span>Source: {lead.source}</span>
                                            </div>
                                        </div>

                                        <div className="lead-actions">
                                            <button
                                                className="btn btn-sm btn-primary"
                                                onClick={() => handleContactClient(lead)}
                                            >
                                                <i className="bi bi-telephone me-1"></i>
                                                Follow Up
                                            </button>
                                            <button
                                                className="btn btn-sm btn-outline-secondary"
                                                onClick={() => handleViewDetails(lead)}
                                            >
                                                <i className="bi bi-eye me-1"></i>
                                                View
                                            </button>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        ) : (
                            <div className="empty-state">
                                <i className="bi bi-person-plus" style={{ fontSize: "3rem", color: "#ccc" }}></i>
                                <p className="text-muted mt-2">
                                    {searchQuery ? "No leads found" : "No leads yet"}
                                </p>
                                <p className="text-muted">
                                    {searchQuery
                                        ? "Try a different search term"
                                        : "New enquiries will appear here"}
                                </p>
                            </div>
                        )}
                    </div>
                )}

                {/* Stats Summary */}
                <div className="stats-summary mt-4">
                    <div className="row g-3">
                        <div className="col-md-3">
                            <div className="stat-box">
                                <div className="stat-icon clients">
                                    <i className="bi bi-people-fill"></i>
                                </div>
                                <div className="stat-content">
                                    <h4>{clients.filter((c) => c.status === "active").length}</h4>
                                    <p>Active Clients</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-3">
                            <div className="stat-box">
                                <div className="stat-icon leads">
                                    <i className="bi bi-person-plus-fill"></i>
                                </div>
                                <div className="stat-content">
                                    <h4>{leads.filter((l) => l.status === "new").length}</h4>
                                    <p>New Leads</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-3">
                            <div className="stat-box">
                                <div className="stat-icon contacted">
                                    <i className="bi bi-chat-dots-fill"></i>
                                </div>
                                <div className="stat-content">
                                    <h4>{leads.filter((l) => l.status === "contacted").length}</h4>
                                    <p>Contacted</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-3">
                            <div className="stat-box">
                                <div className="stat-icon converted">
                                    <i className="bi bi-check-circle-fill"></i>
                                </div>
                                <div className="stat-content">
                                    <h4>{leads.filter((l) => l.status === "converted").length}</h4>
                                    <p>Converted</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </DashboardLayout>
    );
}
